import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function WarningStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M9.44147 3.61524C10.705 1.73422 13.5154 1.79736 14.6758 3.80371L22.3214 17.0205L22.4258 17.2168C23.4294 19.259 21.9878 21.7498 19.6456 21.75H4.35455C1.93692 21.7498 0.478555 19.0955 1.67877 17.0205L9.32428 3.80371L9.44147 3.61524ZM13.377 4.55469C12.7761 3.5158 11.337 3.4831 10.6837 4.45703L10.6231 4.55469L2.9776 17.7725C2.33421 18.8852 3.13569 20.2498 4.35455 20.25H19.6456C20.8264 20.2498 21.6161 18.9687 21.0792 17.877L21.0225 17.7725L13.377 4.55469Z"
				fill="currentColor"
			/>
			<path
				d="M12.0088 16L12.1114 16.0049C12.6156 16.0561 13.0088 16.4823 13.0088 17C13.0088 17.5177 12.6156 17.9439 12.1114 17.9951L12.0088 18H12.0001C11.4478 18 11.0001 17.5523 11.0001 17C11.0001 16.4477 11.4478 16 12.0001 16H12.0088Z"
				fill="currentColor"
			/>
			<path
				d="M11.2501 14V9C11.2501 8.58578 11.5858 8.25 12.0001 8.25C12.4143 8.25 12.7501 8.58578 12.7501 9V14C12.7501 14.4142 12.4143 14.75 12.0001 14.75C11.5858 14.75 11.2501 14.4142 11.2501 14Z"
				fill="currentColor"
			/>
		</svg>
	);
}

WarningStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default WarningStrokeIcon;
